module.exports = __webpack_public_path__ + "img/i_key.fa54a6de.svg";